"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var ArrowUpIcon = function ArrowUpIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.707 15.29a1 1 0 0 1-1.414 0l-4.288-4.288-4.299 4.288a1 1 0 1 1-1.412-1.415l4.3-4.29c.78-.78 2.043-.78 2.823 0l4.29 4.29a1 1 0 0 1 0 1.415z"
  }));
};
ArrowUpIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowDownIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.293 4.293a1 1 0 0 1 1.414 0L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414L13.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 0 1 0-1.414z"
  }));
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "container": "Actions__container__22-5-",
  "icon-button": "Actions__icon-button__NwHa0",
  "iconButton": "Actions__icon-button__NwHa0"
}; 
require('./Actions.css');
var Actions = function Actions(props) {
  var onPrevMatch = props.onPrevMatch,
    onNextMatch = props.onNextMatch,
    onClose = props.onClose;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-test-id": "search-prev-match",
    "aria-label": "Previous search result",
    "aria-describedby": "search-prev-match-description",
    type: "button",
    className: styles.iconButton,
    onClick: onPrevMatch
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(ArrowUpIcon, null))), /*#__PURE__*/_react.default.createElement("span", {
    id: "search-prev-match-description",
    className: "visually-hidden"
  }, "Previous search result"), /*#__PURE__*/_react.default.createElement("button", {
    "data-test-id": "search-next-match",
    "aria-label": "Next search result",
    "aria-describedby": "search-next-match-description",
    type: "button",
    className: styles.iconButton,
    onClick: onNextMatch
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(ArrowDownIcon, null))), /*#__PURE__*/_react.default.createElement("span", {
    id: "search-next-match-description",
    className: "visually-hidden"
  }, "Next search result"), /*#__PURE__*/_react.default.createElement("button", {
    "data-test-id": "search-close",
    "aria-label": "Close search",
    "aria-describedby": "search-close-description",
    type: "button",
    className: styles.iconButton,
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(CloseIcon, null))), /*#__PURE__*/_react.default.createElement("span", {
    id: "search-close-description",
    className: "visually-hidden"
  }, "Close search"));
};
var _default = exports.default = Actions;
//# sourceMappingURL=Actions.js.map